<template>
    <div class="home" style="width: 100%; height: 100%;" draggable="false">
        <Block0/>
        <Block1/>
        <Block2/>
        <Block3 style="margin-top: 30px"/>
        <Footer/>
        <v-dialog
          v-model="helpDialog"
          width="unset"
          style="position: absolute !important; top: 0; "
        >
         <v-card>
          <how-to-verify/>
          <v-card-actions>
            <v-btn
                color="primary"
                text
                @click="helpDialog = false"
                style="position: absolute; right: 5px; top: 10px"
            >
              <v-icon
                  right
                  style="color: gray"
              >mdi-close
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!--PDF Report helpers-->
        <div style="display: none">
            <img id="msbsde_report_header" :src="encodedImages.msbsde_report_header"/>
            <img id="msbsde_sec_signature" :src="encodedImages.msbsde_sec_signature"/>
            <canvas id="msbsde_cert_canvas"></canvas>
            <!--<canvas id="msbsde-report-canvas" style="position: absolute; top: 0; left: 0; transform-origin: top left; border: 1px solid #f00; z-index:3"></canvas>-->
            <canvas id="msbsde-report-canvas"></canvas>
        </div>

    </div>
</template>

<script>
    import Block1 from './home/Block1'
    import Block2 from "./home/Block2";
    import Block3 from "./home/Block3";
    import Block0 from "./home/Block0";
    import Footer from "./home/Footer";
    import HowToVerify from "./home/HowToVerify";
    import encodedImages from '@/assets/encodedImages';

    export default {
        name: 'Home',
        components: {
            HowToVerify,
            Footer,
            Block0,
            Block3,
            Block2,
            Block1
        },
        data: function () {
            return {
                helpDialog: false,
                encodedImages
            }
        },
        mounted() {
          this.$root.$on('open-help', this.clickedHelp);
          this.$root.$on('close-help', () => {
            this.helpDialog = false
          });
        },
        methods: {
          clickedHelp() {
            this.helpDialog = true;
          }
        }
    }
</script>

<style>
    .v-dialog {
        position: absolute;
        top: 0;
    }
</style>
